type Status =
  | 'going'
  | 'maybe'
  | 'not_going'
  | 'pending'
  | 'approved'
  | 'declined'
  | 'live'
  | 'draft'
  | 'filling-up'
  | 'active'
  | 'trialing'
  | 'canceled'
  | 'past_due'
  | 'free'
  | 'unverified'

const STATUS_CONFIG: Record<Status, { label: string; bg: string; ink: string }> = {
  going: { label: 'Going', bg: '#dcfce7', ink: '#15803d' },
  approved: { label: 'Approved', bg: '#dcfce7', ink: '#15803d' },
  active: { label: 'Active', bg: '#dcfce7', ink: '#15803d' },
  live: { label: 'Live', bg: '#dcfce7', ink: '#15803d' },
  maybe: { label: 'Maybe', bg: '#fef3c7', ink: '#b45309' },
  pending: { label: 'Pending', bg: '#fef3c7', ink: '#b45309' },
  trialing: { label: 'Trial', bg: '#fef3c7', ink: '#b45309' },
  'filling-up': { label: 'Filling up', bg: '#fef3c7', ink: '#b45309' },
  not_going: { label: 'Not going', bg: '#fee2e2', ink: '#b91c1c' },
  declined: { label: 'Declined', bg: '#fee2e2', ink: '#b91c1c' },
  canceled: { label: 'Canceled', bg: '#fee2e2', ink: '#b91c1c' },
  past_due: { label: 'Past due', bg: '#fee2e2', ink: '#b91c1c' },
  draft: { label: 'Draft', bg: '#f1f5f9', ink: '#475569' },
  free: { label: 'Free', bg: '#f1f5f9', ink: '#475569' },
  unverified: { label: 'Unverified', bg: '#fffbeb', ink: '#92400e' },
}

interface StatusPillProps {
  status: Status | string
  size?: 'sm' | 'md'
  className?: string
}

export function StatusPill({ status, size = 'sm', className = '' }: StatusPillProps) {
  const cfg = STATUS_CONFIG[status as Status] ?? { label: status, bg: '#f1f5f9', ink: '#475569' }
  const h = size === 'sm' ? 22 : 26
  const fs = size === 'sm' ? 11 : 12.5

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: h,
        padding: `0 ${size === 'sm' ? 8 : 10}px`,
        borderRadius: 999,
        background: cfg.bg,
        color: cfg.ink,
        fontSize: fs,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        letterSpacing: '0.01em',
      }}
    >
      {cfg.label}
    </span>
  )
}
